import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { VehicleTemplate } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createVehicleTemplateApi, vehicleTemplateKeys } from '../api';

export function useArchiveVehicleTemplate(): UseMutationResult<VehicleTemplate, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createVehicleTemplateApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<VehicleTemplate, Error, string>({
    mutationFn: (id: string) => api.archiveVehicleTemplate(id),
    ...createMutationCallbacks({
      errorKey: 'vehicleTemplates.toast.archiveError',
      invalidateKeys: [vehicleTemplateKeys.lists()],
      queryClient,
      successKey: 'vehicleTemplates.toast.archived',
      t,
    }),
  });
}
